import { Button } from '@mui/material';
import React, { useState } from 'react';

import backIcon from '../../assets/icons/icon_back.svg';
import menuIcon from '../../assets/icons/icon_menu.svg';
import { ColoredIcon, IconButton } from '../../common/components/Icon';

import { MenuDrawer } from './MenuDrawer';
import {
  LayoutHeaderContainer,
  LayoutHeaderContent,
  LayoutHeaderContentLeft,
  LayoutHeaderContentRight,
} from './components';

interface MobileModalHeaderProps {
  onGoBack: () => void;
}
export const MobileModalHeader = (props: MobileModalHeaderProps) => {
  const { onGoBack } = props;

  const [openMenu, setOpenMenu] = useState(false);

  return (
    <LayoutHeaderContainer $height="56px">
      <LayoutHeaderContent>
        <LayoutHeaderContentLeft>
          <IconButton
            width="16px"
            height="16px"
            imageUrl={backIcon}
            imageWidth="16px"
            color="white"
            onClick={onGoBack}
          />
        </LayoutHeaderContentLeft>
        <LayoutHeaderContentRight $gap="28px">
          <Button onClick={() => setOpenMenu(true)}>
            <ColoredIcon
              width="18px"
              height="18px"
              imageUrl={menuIcon}
              imageWidth="16px"
              color="white"
            />
          </Button>
        </LayoutHeaderContentRight>
        <MenuDrawer
          open={openMenu}
          onOpen={() => setOpenMenu(true)}
          onClose={() => {
            setOpenMenu(false);
            onGoBack?.();
          }}
          modalDrawer
        />
      </LayoutHeaderContent>
    </LayoutHeaderContainer>
  );
};
